// libs
import React from 'react';

import { cn } from '@lyearn/style';
// components
import { Typography } from '@lyearn/ui';

import RichTextContainer from '../RichTextContainer';
import { wordBreakBreakWord } from './styles';
// types
import { RichTextProps } from './types';

interface RichTextViewerProps extends RichTextProps {
  html: string;
}

function RichTextViewer(props: RichTextViewerProps) {
  const { html, className, containerClassName, truncate, truncateLength, variant, ...rest } = props;
  return (
    <RichTextContainer className={containerClassName}>
      <Typography
        {...rest}
        className={cn(wordBreakBreakWord, className)}
        variant={variant ?? 'body-long-01'}>
        <span dangerouslySetInnerHTML={{ __html: html }} className="html-container" />
      </Typography>
    </RichTextContainer>
  );
}

export default RichTextViewer;
